// Rezervasyon Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'reservations.page';

export const reservationsPageGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Rezervasyon Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Online bilet / rezervasyon kayıtlarınızı dört sekmede yönetirsiniz: tüm rezervasyonlar, onay bekleyen başvurular, girişte kullanılanlar ve şubelerin müsait saat takvimleri. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve özet kartları'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
  },
  navItems: [
    t(`${G}.nav.list`, 'Rezervasyon Listesi'),
    t(`${G}.nav.applications`, 'Rezervasyon Başvuruları'),
    t(`${G}.nav.entryExit`, 'Giriş Çıkış Kaydı'),
    t(`${G}.nav.branches`, 'Şubeler'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki kartlar Toplam Rezervasyon, Onaylı Rezervasyon, Bekleyen Başvuru ve Girişte Kullanılan sayılarını gösterir. Sayılar en son 500 online bilet rezervasyonundan hesaplanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Rezervasyon Listesi'),
      text: t(`${G}.s2.text`, 'Tüm rezervasyonlar Tarih, Müşteri, Telefon No, Rezervasyon No, Kişi Sayısı, Şube, Tutar ve Durum sütunlarıyla listelenir. Tarih, Kişi Sayısı ve Tutar başlıklarına tıklayarak sıralayabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sıra numarasının yanındaki ok Rezervasyon Detayını açar: her kişinin adı, bilet türü (Yetişkin, Çocuk, Ücretsiz) ve tutarı görünür.'),
        t(`${G}.s2.tip2`, 'Satırın sonundaki ⋮ menüsündeki "Yazdır" rezervasyon detayını yazdırma sayfası olarak açar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Rezervasyon Başvurularını onaylayın'),
      text: t(`${G}.s3.text`, 'Bu sekmede yalnız onay bekleyen başvurular listelenir. "Onayla" rezervasyonu onaylar, "Reddet" reddeder; işlenen başvuru listeden kalkar ve durumu Rezervasyon Listesinde görünür.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ödemesi başarıyla alınmış rezervasyonlar onaylı sayılır, bu listeye düşmez ve reddedilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Giriş Çıkış Kaydı'),
      text: t(`${G}.s4.text`, 'Girişte kullanılmış (Kullanıldı) rezervasyonlar burada Rezervasyon No, Müşteri, Şube, Rezervasyon Tarihi ve Kayıt Zamanı ile listelenir. Bu sekme yalnız görüntüleme içindir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Şubeler: müsait saatler ve istekler'),
      text: t(`${G}.s5.text`, 'Şubeler sekmesinde bir şubenin satırındaki "Aç" düğmesi o şubenin Müsait Saatler takvimini açar. Orada rezervasyona açık saatleri belirler, "Rezervasyon İsteklerini Görüntüle" ile şubeye gelen istekleri takvimde görüp onaylar veya reddedersiniz.'),
    },
  ],
});
